var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPencilLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1066 7.98024L11.9281 6.80173L4.16667 14.5632V15.7417H5.34517L13.1066 7.98024ZM14.2851 6.80173L15.4636 5.62322L14.2851 4.4447L13.1066 5.62322L14.2851 6.80173ZM6.03553 17.4083H2.5V13.8728L13.6958 2.67694C14.0213 2.3515 14.5489 2.3515 14.8743 2.67694L17.2314 5.03396C17.5568 5.35939 17.5568 5.88704 17.2314 6.21247L6.03553 17.4083Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencilLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil-line.026c827a.svg";
export { ForwardRef as ReactComponent };